import {ModuleWithProviders, NgModule} from '@angular/core';

import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {ModalBackdropComponent} from '@catmodules/widgets/slide-in-modal/components/modal-backdrop.component';
import {ModalContentComponent} from '@catmodules/widgets/slide-in-modal/components/modal-content/modal-content.component';
import {ModalWindowComponent} from '@catmodules/widgets/slide-in-modal/components/modal-window.component';
import {ModalStackService} from '@catmodules/widgets/slide-in-modal/services/modal-stack.service';
import {ActiveModal} from '@catmodules/widgets/slide-in-modal/utils/modal-ref';
import {UIBaseModule} from '@catui/ui-base.module';
import {ModalService} from './services/modal.service';

export {ModalRef, ActiveModal} from './utils/modal-ref';
export {ModalDismissReasons} from './types/modal-dismiss-reasons';

const publicComponents = [ModalContentComponent];

@NgModule({
  imports: [
    BrowserAnimationsModule,
    UIBaseModule,
  ],
  declarations: [
    ModalBackdropComponent,
    ModalWindowComponent,
    ...publicComponents,
  ],
  entryComponents: [
    ModalBackdropComponent,
    ModalWindowComponent,
  ],
  providers: [ModalService, ModalStackService, ActiveModal],
  exports: [...publicComponents],
})
export class SlideInModalModule {
  static forRoot(): ModuleWithProviders {
    return {ngModule: SlideInModalModule, providers: [ModalService, ModalStackService]};
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/widgets/slide-in-modal/slide-in-modal.module.ts